module.exports = __webpack_public_path__ + "static/media/17240706_10210411002286260_4284718433374179097_o.107543cb.jpg";